import { EnderecoDTO } from "./enderecoDTO";

export class RegionalDTO {
  public id!: string | null;
  public nome!: string;
  public email!: string;
  public enderecoDTO!: EnderecoDTO | undefined;
  public telefoneComercial!: string;
  public telefoneCelular!: string;
  public codigoExterno!: string;
  public idMatriz!: string;
  public razaoSocial!: string;
}